import { useContext, useEffect, useState } from 'react'
import './foodItem.scss'
import {
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Space,
  Tooltip
} from 'antd'
import { FormProps } from 'antd/es/form/Form'
import TextArea from 'antd/es/input/TextArea'
// import TimeSelector from "../Timpicker/timepicker";
import { updateFoodItem } from '../../Utility/Menu/category.util'
import TimeSlotSelector from '../TimeSlotSelect/timeSlotSelectComponent'
import { MenuContext } from '../../Pages/MenuPage/menuPage'
import { CUISINE_DROPDOWN_OPTIONS } from '../../MetaData/cuisine.metadata'
import UploadImage from '../uploadImage/uploadimage'
const FoodItem = ({
  foodItemList,
  vendorInfo,
  onUpdate,
  getAddOns,
  checkAddonUsage,
  isLive
}: any) => {
  const cuisineOptions = CUISINE_DROPDOWN_OPTIONS
  console.log(foodItemList)
  const { timeSlots } = useContext(MenuContext)
  console.log('timeSlots', timeSlots)
  const [form] = Form.useForm()
  const onFinish: FormProps['onFinish'] = (values) => {
    console.log('hi', values)
  }
  const onFinishFailed = () => {
    console.log('hi')
  }

  const [isAddon, setIsAddON] = useState(false)
  const [addOnlist, setAddOnList] = useState([{ label: '', value: '' }])

  useEffect(() => {
    form.resetFields()
    setIsAddON(foodItemList.isAddon || false)
  }, [foodItemList])

  useEffect(() => {
    if (foodItemList.category_id === '999') {
      setIsAddON(true)
    }
    isAddon ? '' : setAddOnList(getAddOns)
  }, [])

  const handleIsAddonChange = (e: any) => {
    const newIsAddon = e.target.checked
    console.log('Is Addon changed to:', newIsAddon)
    // If trying to uncheck, validate if item is used in addon groups
    if (!newIsAddon && foodItemList.isAddon) {
      const usage = checkAddonUsage(foodItemList.food_id)
      if (usage.groupNames.length > 0) {
        Modal.error({
          title: 'Cannot Remove Addon Status',
          content: `This item is being used as an addon in: ${usage.groupNames.join(', ')}. Please remove it from these groups first.`
        })
        form.setFieldValue('isAddon', true)
        return
      }
    }

    setIsAddON(newIsAddon)
    form.setFieldValue('isAddon', newIsAddon)
    console.log('Form updated isAddon to:', form.getFieldValue('isAddon'))
    // Clear addon groups when making item an addon
    if (newIsAddon) {
      form.setFieldValue('addonGroupIds', [])

      // Set all days with 'All Day' time slot for addon items
      const allDays = Object.keys(foodItemList.availableHours)
      form.setFieldValue('availableDays', allDays)

      // Set 'All Day' time slot for each day
      allDays.forEach((day: string) => {
        form.setFieldValue(day, ['All Day'])
      })
    }
  }

  const updatePrice = () => {
    const totalPrice = +form.getFieldValue('totalPrice') || 0
    const categoryType = form.getFieldValue('categoryType')
    const gstPercentage =
      categoryType === 'Fresh'
        ? +form.getFieldValue('gstPercentage')
        : 0
    if (categoryType === 'Packaged') {
      form.setFieldValue('packaging', false)
      form.setFieldValue('gstPercentage', 0)
      form.setFieldValue('gst', 0)
    }
    const packagingCharges = form.getFieldValue('packaging')
      ? +form.getFieldValue('packaging_charges')
      : 0

    console.log('Calculating price from total:', {
      totalPrice,
      gstPercentage,
      packagingCharges
    })

    let price = 0
    let calculatedGst = 0

    //set packaging charges to 0 if packaging is false
    if (form.getFieldValue('packaging') === false) {
      form.setFieldValue('packaging_charges', 0)
    }

    if (
      vendorInfo.gstCategoryType === '1' ||
      (vendorInfo.gstCategoryType === '3' && categoryType === 'Fresh')
    ) {
      // Calculate price from total: totalPrice = price + (price * gst%)
      // Therefore: price = totalPrice / (1 + gst%/100)
      const priceBeforeGst = totalPrice / (1 + gstPercentage / 100)
      price = Number(priceBeforeGst.toFixed(2))
      calculatedGst = Number((totalPrice - price).toFixed(2))
      form.setFieldValue('gst', calculatedGst)
    } else {
      // No GST included in price
      price = Number(totalPrice.toFixed(2))
      form.setFieldValue('gst', 0)
    }

    form.setFieldValue('price', price)
    console.log('Updated price:', price, 'GST:', calculatedGst)
  }

  const updateTotalPriceFromPrice = () => {
    const price = +form.getFieldValue('price') || 0
    const categoryType = form.getFieldValue('categoryType')
    const gstPercentage =
      categoryType === 'Fresh'
        ? +form.getFieldValue('gstPercentage')
        : 0
    if (categoryType === 'Packaged') {
      form.setFieldValue('packaging', false)
      form.setFieldValue('gstPercentage', 0)
      form.setFieldValue('gst', 0)
    }
    const packagingCharges = form.getFieldValue('packaging')
      ? +form.getFieldValue('packaging_charges')
      : 0

    console.log('Calculating total price from price:', {
      price,
      gstPercentage,
      packagingCharges
    })

    let totalPrice = 0
    let calculatedGst = 0

    //set packaging charges to 0 if packaging is false
    if (form.getFieldValue('packaging') === false) {
      form.setFieldValue('packaging_charges', 0)
    }

    if (
      vendorInfo.gstCategoryType === '1' ||
      (vendorInfo.gstCategoryType === '3' && categoryType === 'Fresh')
    ) {
      totalPrice = price * (1 + gstPercentage / 100)
      calculatedGst = Number((totalPrice - price).toFixed(2))
      form.setFieldValue('gst', calculatedGst)
    } else {
      totalPrice = price
      form.setFieldValue('gst', 0)
    }

    form.setFieldValue('totalPrice', Number(totalPrice.toFixed(2)))
    console.log('Updated total price:', totalPrice, 'GST:', calculatedGst)
  }

  const availableDays = Form.useWatch('availableDays', form)

  const handleChange = (value: string[]) => {
    console.log(value)
  }

  const handleSelectAllDays = () => {
    const allDays = Object.keys(foodItemList.availableHours)
    form.setFieldValue('availableDays', allDays)
  }

  const applyTimeSlotsToAllDays = () => {
    if (!availableDays || availableDays.length === 0) {
      Modal.warning({
        title: 'No days selected',
        content: 'Please select at least one day first.'
      })
      return
    }

    // Get the time slots from the first selected day
    const firstDay = availableDays[0]
    const firstDaySlots = form.getFieldValue(firstDay)

    if (!firstDaySlots || firstDaySlots.length === 0) {
      Modal.warning({
        title: 'No time slots set',
        content: `Please set time slots for ${firstDay} first.`
      })
      return
    }

    // Apply to all other selected days
    availableDays.forEach((day: string) => {
      if (day !== firstDay) {
        form.setFieldValue(day, firstDaySlots)
      }
    })

    Modal.success({
      title: 'Time Slots Applied',
      content: `Time slots from ${firstDay} have been applied to all selected days.`
    })
  }

  const updateItem = async () => {
    try {
      const values = await form.validateFields()
      console.log('updating food values', foodItemList, values)
      updateFoodItem(foodItemList, values)
      onUpdate()
    } catch (error) {
      console.log('Validation failed:', error)
      // Form will automatically show error messages for invalid/missing fields
    }
  }

  const onImageUpload = (image: any) => {
    foodItemList.images = image
  }

  const selecetedCategory = Form.useWatch('categoryType', form)
  const selecetedPackaging = Form.useWatch('packaging', form)
  // Auto-set packaging to false when category is packaged
  useEffect(() => {
    if (selecetedCategory === 'Packaged') {
      form.setFieldValue('packaging', false)
      form.setFieldValue('packaging_charges', 0)
    }
  }, [selecetedCategory, form])

  return (
    <>
      <h1>{foodItemList.label}</h1>

      <Form
        disabled={isLive}
        form={form}
        name='Food Item'
        // labelCol={{ span:  }}
        labelAlign='left'
        labelWrap={true}
        style={
          {
            // maxWidth: 1200,
            // gap: "20px",
            // alignItems: "left"
          }
        }
        scrollToFirstError
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
      >
        <div className='pricing'>
          <h2>Pricing</h2>
          <div className='priceRow'>
            <Form.Item
              label={'Total Price'}
              initialValue={foodItemList.totalPrice}
              style={{ fontSize: 20, width: '300px' }}
              name='totalPrice'
              rules={[
                {
                  required: true,
                  message: 'Price is required'
                },
                {
                  pattern: /^(?!0(\.0+)?$)(0|[1-9]\d{0,4})(\.\d{1,2})?$/,
                  message: 'Price must be greater than 0'
                }
              ]}
            >
              <Input
                size='large'
                placeholder='total price'
                onChange={() => updatePrice()}
              />
            </Form.Item>
            {
              // vendorInfo.gstCategoryType === '3' &&
              <Form.Item
                label='Category'
                initialValue={
                  vendorInfo.gstCategoryType !== '2'
                    ? foodItemList.categoryType
                    : 'Packaged'
                }
                style={{ fontSize: 20, width: '300px' }}
                name='categoryType'
                rules={[
                  {
                    required: true,
                    message: 'CategoryType is required'
                  }
                ]}
              >
                <Select
                  disabled={vendorInfo.gstCategoryType === '2' || isLive}
                  onSelect={() => updatePrice()}
                  options={[
                    { value: 'Fresh', label: 'Fresh' },
                    { value: 'Packaged', label: 'Packaged' }
                  ].filter((item) => {
                    if (vendorInfo.gstCategoryType === '2') {
                      return item.value === 'Packaged'
                    } else if (vendorInfo.gstCategoryType === '1') {
                      return item.value === 'Fresh'
                    }
                    return true
                  })}
                />
              </Form.Item>
            }
            {(vendorInfo.gstCategoryType === '1' ||
              (vendorInfo.gstCategoryType === '3' &&
                selecetedCategory === 'Fresh')) && (
              <Form.Item
                label={'GST Percentage'}
                initialValue={foodItemList.gstPercentage}
                style={{ fontSize: 20, width: '300px' }}
                name='gstPercentage'
                rules={[
                  {
                    required: true,
                    message: 'Price is required'
                  }
                ]}
              >
                <Select
                  onSelect={() => updatePrice()}
                  options={[
                    // { value: 0, label: '0%' },
                    { value: 5, label: '5%' },
                    { value: 18, label: '18%' }
                    // { value: 10, label: '10%' },
                    // { value: 15, label: '15%' }
                  ]}
                />
              </Form.Item>
            )}
            {(vendorInfo.serviceType === '4' ||
              vendorInfo.serviceType === '5' ||
              vendorInfo.serviceType === '6' ||
              vendorInfo.serviceType === '7') && (
              <Form.Item
                label='Packaging'
                initialValue={foodItemList.packaging}
                style={{ fontSize: 20, width: '300px' }}
                name='packaging'
                rules={[
                  {
                    required: true,
                    message: 'Packaging is required'
                  }
                ]}
              >
                <Select
                  disabled={selecetedCategory === 'Packaged' || isLive}
                  onSelect={() => updatePrice()}
                  options={[
                    { value: true, label: 'True' },
                    { value: false, label: 'False' }
                  ]}
                />
              </Form.Item>
            )}
            {selecetedPackaging && (
              <Form.Item
                label={'Packaging Price'}
                initialValue={foodItemList.packaging_charges}
                style={{ fontSize: 20, width: '300px' }}
                name='packaging_charges'
                rules={[
                  {
                    required: true,
                    message: 'Price is required'
                  },
                  {
                    pattern: /^(0|[1-9]\d{0,4})(\.\d{1,2})?$/,
                    message: 'Price is invalid'
                  }
                ]}
              >
                <Input
                  onChange={() => updatePrice()}
                  size='large'
                  placeholder='packaging price'
                />
              </Form.Item>
            )}

            <Form.Item
              label={'Price'}
              initialValue={foodItemList.price}
              style={{ fontSize: 20, width: '300px' }}
              name='price'
              rules={[
                {
                  required: true,
                  message: 'Price is required'
                },
                {
                  pattern: /^(?!0(\.0+)?$)(0|[1-9]\d{0,4})(\.\d{1,2})?$/,
                  message: 'Price must be greater than 0'
                }
              ]}
            >
              <Input
                placeholder='price'
                size='large'
                onChange={() => updateTotalPriceFromPrice()}
              />
            </Form.Item>
          </div>
        </div>
        <div className='description'>
          <h2>Description</h2>
          <div className='secondRow'>
            <Form.Item
              label={'Description'}
              initialValue={foodItemList.description}
              style={{ fontSize: 20, width: '300px', flex: 1 }}
              name='description'
              rules={[
                {
                  required: true,
                  message: 'Price is required'
                }
              ]}
            >
              <TextArea
                style={{ color: 'black', minWidth: '300px' }}
                rows={4}
                placeholder='maxLength is 500'
                maxLength={500}
              />
            </Form.Item>
          </div>
          <div style={{ marginTop: '10px' }}>
            <Form.Item
              name='isAddon'
              initialValue={foodItemList.isAddon || false}
              valuePropName='checked'
            >
              <Checkbox onChange={handleIsAddonChange} checked={isAddon}>
                <span style={{ fontSize: '16px', fontWeight: 500 }}>
                  Make this item available as an addon
                </span>
              </Checkbox>
            </Form.Item>
          </div>
        </div>

        <div className='food_details'>
          <h2>Food Details</h2>
          <div className='thirdRow'>
            <Form.Item
              label='Servings per persons'
              initialValue={foodItemList.servings}
              style={{ fontSize: 20, width: '300px' }}
              name='servings'
              rules={[
                {
                  required: true,
                  message: 'Servings is required'
                },
                {
                  pattern: /^[0-5]{1}$/,
                  message: 'Price is invalid'
                }
              ]}
            >
              <Input size='large' placeholder='sevings per person' />
            </Form.Item>
            {!isAddon && (
              <Form.Item
                label='Select Addon Groups'
                initialValue={foodItemList.addonGroupIds || []}
                style={{ fontSize: 20, width: '300px' }}
                name='addonGroupIds'
              >
                <Select
                  mode='multiple'
                  allowClear
                  placeholder='Select addon groups for this item'
                  optionLabelProp='label'
                  disabled={isAddon}
                >
                  {addOnlist.map((group: any) => (
                    <Select.Option
                      key={group.group_id}
                      value={group.group_id}
                      label={group.label}
                    >
                      <div>
                        <div style={{ fontWeight: 'bold' }}>{group.label}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          {group.selectionType === 'SINGLE_SELECT'
                            ? '🔘 Single'
                            : '☑️ Multi'}{' '}
                          ({group.minSelect}-{group.maxSelect}) •{' '}
                          {group.addons?.length || 0} items
                        </div>
                      </div>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {isAddon && (
              <Tooltip title='Addon items cannot have their own addons'>
                <Form.Item
                  label='Select Addon Groups'
                  style={{ fontSize: 20, width: '300px' }}
                >
                  <Select
                    mode='multiple'
                    disabled={true}
                    placeholder='Not available for addon items'
                  />
                </Form.Item>
              </Tooltip>
            )}
            <Form.Item
              label='Veg/NonVeg/Egg'
              initialValue={foodItemList.type}
              style={{ fontSize: 20, width: '300px' }}
              name='type'
              rules={[
                {
                  required: true,
                  message: 'Type is required'
                }
              ]}
            >
              <Select
                options={[
                  { value: 'NONVEG', label: 'NONVEG' },
                  { value: 'VEG', label: 'VEG' },
                  { value: 'EGG', label: 'EGG' }
                ]}
              />
            </Form.Item>

            <Form.Item
              label='Vegan'
              initialValue={foodItemList.vegan}
              style={{ fontSize: 20, width: '300px' }}
              name='vegan'
              rules={[
                {
                  required: true,
                  message: 'Vegan is required'
                }
              ]}
            >
              <Radio.Group>
                <Radio value={true}>True</Radio>
                <Radio value={false}>False</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label='Healthy'
              initialValue={foodItemList.healthy}
              style={{ fontSize: 20, width: '300px' }}
              name='healthy'
              rules={[
                {
                  required: true,
                  message: 'Healthy is required'
                }
              ]}
            >
              <Radio.Group>
                <Radio value={true}>True</Radio>
                <Radio value={false}>False</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label='Cuisine'
              initialValue={foodItemList.cuisine}
              style={{ fontSize: 20, width: '300px' }}
              name='cuisine'
              rules={[
                {
                  required: true,
                  message: 'Cuisine is required'
                }
              ]}
            >
              <Select options={cuisineOptions} />
            </Form.Item>
          </div>
          <div></div>
        </div>
        {!isAddon && (
          <div className='stock-management' style={{ marginBottom: '30px' }}>
            <h2>Stock Management</h2>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
              <Form.Item
                label='Initial Stock Per Day'
                initialValue={foodItemList.stock?.initialStockPerDay || 100}
                style={{ fontSize: 20, width: '250px' }}
                name={['stock', 'initialStockPerDay']}
                rules={[
                  {
                    required: true,
                    message: 'Initial stock is required'
                  }
                ]}
              >
                <Input
                  type='number'
                  min={0}
                  placeholder='Daily stock quantity'
                />
              </Form.Item>

              <Form.Item
                label='Current Stock'
                initialValue={foodItemList.stock?.currentStock || 100}
                style={{ fontSize: 20, width: '200px' }}
                name={['stock', 'currentStock']}
                rules={[
                  {
                    required: true,
                    message: 'Current stock is required'
                  }
                ]}
              >
                <Input type='number' min={0} placeholder='Available now' />
              </Form.Item>

              <Form.Item
                label='Auto Refresh Stock'
                initialValue={foodItemList.stock?.autoRefresh || false}
                style={{ fontSize: 20, width: '200px' }}
                name={['stock', 'autoRefresh']}
                valuePropName='checked'
              >
                <Radio.Group>
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
          </div>
        )}
        {!isAddon && (
          <div className='availability'>
            <h2> Availability</h2>
            <div className='workingHours_class'>
              <div
                style={{
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'flex-start',
                  marginBottom: '10px'
                }}
              >
                <Form.Item
                  label='AvailableDays'
                  initialValue={foodItemList.availableDays}
                  style={{ fontSize: 20, width: '300px', marginBottom: 0 }}
                  name='availableDays'
                  rules={[
                    {
                      required: true,
                      message: 'Select atleast 1 availbale day'
                    }
                  ]}
                >
                  <Select
                    mode='multiple'
                    allowClear
                    style={{ width: '100%' }}
                    placeholder='Please select'
                    // defaultValue={foodItemList.availableDays}
                    onChange={handleChange}
                    options={Object.keys(foodItemList.availableHours).map(
                      (key: string) => ({
                        value: key,
                        label: key
                      })
                    )}
                  />
                </Form.Item>
                <Button type='default' onClick={handleSelectAllDays}>
                  Select All Days
                </Button>
              </div>
              {availableDays && availableDays.length > 1 && (
                <Button
                  type='primary'
                  onClick={applyTimeSlotsToAllDays}
                  style={{ marginBottom: '20px' }}
                >
                  Apply {availableDays[0]}'s Time Slots to All Days
                </Button>
              )}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '50px' }}>
              {availableDays?.map((availableDay: string) => {
                return (
                  // <TimeSelector
                  //     key={availableDay}
                  //     initialValue={Object.keys(foodItemList.availableHours)
                  //         .filter((day: string) => day === availableDay)
                  //         .flatMap((reqDay: string) => {
                  //             return [foodItemList.availableHours[reqDay].workingHours.open, foodItemList.availableHours[reqDay].workingHours.close]
                  //         })
                  //     }
                  //     label={`${availableDay} start and end time`}
                  //     controlName={availableDay}
                  //     validators={[{ required: true, message: `PLease select open and close time for ${availableDay}` }]}
                  //     avalialbleHours={foodItemList.availableHours}
                  //     onTimeChange={() => console.log()}
                  // />
                  <TimeSlotSelector
                    key={availableDay}
                    initialValue={Object.keys(foodItemList.availableHours)
                      .filter((day: string) => day === availableDay)
                      .flatMap(
                        (day: string) => foodItemList.availableHours[day]
                      )}
                    label={`${availableDay} time slots`}
                    controlName={availableDay}
                    validators={[
                      {
                        required: true,
                        message: `Please select time slots for ${availableDay}`
                      }
                    ]}
                    avalialbleSlots={timeSlots.map((timeSlot) => {
                      return {
                        label: timeSlot.slotName,
                        desc: `${timeSlot.slotName} - ${timeSlot.availableHours.from} to ${timeSlot.availableHours.to}`,
                        value: timeSlot.slotName
                      }
                    })}
                    onTimeChange={() => console.log()}
                  />
                )
              })}
            </div>
          </div>
        )}

        <div className='photo'>
          <h2>Photos</h2>
          <div className='image_container'>
            <UploadImage
              images={foodItemList.images}
              fileType={`${vendorInfo.restaurantId}/FoodImages`}
              onImageUpload={(e: any) => {
                onImageUpload(e)
              }}
            />
          </div>
        </div>

        <Space size={30}>
          <Button
            type='primary'
            style={{ width: '100px' }}
            onClick={updateItem}
            disabled={
              form.getFieldsError().filter((fields) => fields.errors.length > 0)
                .length > 0
            }
          >
            Update
          </Button>
          <Button
            style={{ background: 'red', color: 'white', width: '100px' }}
            onClick={onUpdate}
            disabled={false}
          >
            Cancel
          </Button>
        </Space>
      </Form>
    </>
  )
}

export default FoodItem
